import React from "react";

export function BookDemoworld() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8.00008 14.3333C11.4979 14.3333 14.3334 11.4978 14.3334 7.99999C14.3334 4.50218 11.4979 1.66666 8.00008 1.66666C4.50227 1.66666 1.66675 4.50218 1.66675 7.99999C1.66675 11.4978 4.50227 14.3333 8.00008 14.3333Z" stroke="#677492" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.99964 14.3333C9.55424 14.3333 10.8144 11.4978 10.8144 7.99999C10.8144 4.50218 9.55424 1.66666 7.99964 1.66666C6.44505 1.66666 5.18481 4.50218 5.18481 7.99999C5.18481 11.4978 6.44505 14.3333 7.99964 14.3333Z" stroke="#677492" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.66675 8H14.3334" stroke="#677492" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
